export default "__VITE_ASSET__BWSLpkj1__"